import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider, theme } from "antd";
import store, { persistor } from "./store/store";
import router from "./router.jsx";
import { ToastContainer} from "react-toastify";
import { getTheme } from "./utils/domainConfig";
import { SITE_THEMES } from "./config/siteThemes";

// skin themes (Site Theme page se domain-wise, rang siteThemes.js palette) — default pe gold/magenta.
// Theme backend se baad me aa sakti hai (main.jsx 'site-theme-change' event) — isliye function.
const buildAntdTheme = (themeKey) => {
const pal = SITE_THEMES[themeKey]?.palette;
const P = pal
  ? { primary: pal.accent, link: pal.accent, head: pal.tableHead || pal.dark, headText: pal.tableHeadText || "#ffffff", headSort: pal.tableHeadSort || pal.dark2, hover: `${pal.accent}1f`, shadow: `${pal.accent}80` }
  : { primary: "#f4c042", link: "#c02b64", head: "#f4c042", headText: "#1a1a2e", headSort: "#dba934", hover: "rgba(244,192,66,0.12)", shadow: "rgba(244,192,66,0.6)" };

return {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: P.primary,
    colorInfo: P.primary,
    colorLink: P.link,
    borderRadius: 6,
    fontFamily:
      "'NoirPro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    controlHeight: 36,
    // Align antd surfaces with the app palette (see src/index.css :root)
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBorder: "#e5e5e5",
    colorText: "#1a1a2e",
    colorTextPlaceholder: "#9ca3af",
  },
  components: {
    Table: {
      headerBg: P.head,
      headerColor: P.headText,
      headerSortActiveBg: P.headSort,
      rowHoverBg: P.hover,
      borderColor: "#e5e5e5",
    },
    Button: { primaryShadow: `0 4px 14px -6px ${P.shadow}` },
    DatePicker: { activeBorderColor: P.link, hoverBorderColor: P.link },
  },
};
};

function App() {
  const [themeKey, setThemeKey] = useState(getTheme());
  useEffect(() => {
    const on = () => setThemeKey(getTheme());
    window.addEventListener("site-theme-change", on);
    return () => window.removeEventListener("site-theme-change", on);
  }, []);
  const antdTheme = buildAntdTheme(themeKey);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider theme={antdTheme}>
          <RouterProvider router={router} />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            theme="colored"
            pauseOnHover
          />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
